export default __webpack_public_path__ + "static/media/Kitchen-Appliances-mob.524389e3.jpg";